<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 40 40"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect height="36.9999" rx="2.5" :stroke="fill" stroke-width="3" width="37" x="1.5" y="1.5"/>
    <rect :fill="fill" height="2" width="36" x="2" y="7"/>
    <circle cx="6" cy="5" :fill="fill" r="1"/>
    <circle cx="10" cy="5" :fill="fill" r="1"/>
    <circle cx="14" cy="5" :fill="fill" r="1"/>
    <rect height="5.99998" rx="2.99999" :stroke="fill" stroke-width="2" width="6" x="7" y="13.6665"/>
    <rect height="5.99998" rx="2.99999" :stroke="fill" stroke-width="2" width="6" x="17" y="13.6666"/>
    <rect height="5.99998" rx="2.99999" :stroke="fill" stroke-width="2" width="6" x="27" y="13.6665"/>
    <rect :fill="fill" height="2" rx="1" width="28" x="6" y="25"/>
    <rect :fill="fill" height="2" rx="1" width="28" x="6" y="29"/>
    <rect :fill="fill" height="2" rx="1" width="28" x="6" y="33"/>
  </svg>

</template>

<script>
export default {
  name: 'WebPage',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
